import React, { Fragment } from 'react';
import {
	Control,
	FieldValues,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

import { Label, RadioButton, Select } from '@components/common';
import { IFieldsAlarmManagementForm } from '@components/ModalComponents/AlarmManagementForm/AlarmManagementForm';

import { IAlarmManagement } from '@interfaces/alarms/alarm';
import { IValueLabelColor } from '@interfaces/common/common';

import { EAlarmManagementFields } from '@components/ModalComponents/AlarmManagementForm/enums';

import { nonNullishMinutesOptions } from '@constants/timeOptions';

import styles from './BasicInformation.module.scss';
import stylesLabel from '@components/ModalComponents/AlarmManagementForm/AlarmManagementForm.module.scss';

interface IBasicInformationProps {
	watch: UseFormWatch<IFieldsAlarmManagementForm>;
	setValue: UseFormSetValue<FieldValues>;
	control: Control;
	fields: IValueLabelColor[];
	editableAlarm?: IAlarmManagement;
}

const BasicInformation = ({
	watch,
	setValue,
	fields,
	control,
	editableAlarm,
}: IBasicInformationProps) => {
	const isActive = watch(EAlarmManagementFields.isActive);

	return (
		<div className={styles.basicInformationContainer}>
			<div className={styles.status}>
				<Label
					className={stylesLabel.label}
					label='Status'
					required
				/>
				<div className={styles.checkboxes}>
					<RadioButton
						checked={isActive}
						id='active'
						label='Enabled'
						name={EAlarmManagementFields.isActive}
						setValue={setValue}
						value
						withUseForms
					/>
					<RadioButton
						checked={!isActive}
						id='inactive'
						label='Disabled'
						name={EAlarmManagementFields.isActive}
						setValue={setValue}
						value={false}
						withUseForms
					/>
				</div>
			</div>
			<div className={styles.info}>
				{fields.map(field => {
					const { value, label, color } = field;

					return (
						<Fragment key={label}>
							<div
								className={styles.title}>{label}</div>
							<div className={styles.text}>
								{color && (
									<span
										className={styles.color}
										style={{ background: color }}
									/>
								)}
								{value}
							</div>
						</Fragment>
					);
				})
				}
			</div>
			{editableAlarm?.autoClearMinutes && (
				<div className={styles.status}>
					<div className={styles.labelWrapper}>
						<Label
							className={stylesLabel.label}
							label='Autoclear Timer'
							required
							tooltipContent='The time interval from the moment the alarm occurs, after which the alarm will be cleared'
						/>
					</div>
					<div className={styles.autoClearWrapper}>
						<div className={styles.timeSection}>
							<Select
								control={control}
								maxMenuHeight={120}
								menuPlacement='top'
								minWidth='80px'
								name={EAlarmManagementFields.autoClearMinutes}
								options={nonNullishMinutesOptions}
								placeholder='mm'
								required
							/>
							<div>min</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default BasicInformation;
